import { createAction, props } from '@ngrx/store';

export const setLanguage = createAction('[General] Set Language', props<{ language: string | null }>());

export const setGPTiframe = createAction('[General] Set GPT Iframe', props<{ GPTiframe: boolean }>());

export const setJansenFilter = createAction(
  '[General] Set Jansen Filter',
  props<{ language: string; categoryId: number; searchTerm?: string }>()
);

export const downloadDocumentStart = createAction('[General] Download Document Start');
export const downloadDocumentEnd = createAction('[General] Download Document End');
export const setDownloadDocumentFilename = createAction(
  '[General] Set Download Document Filename',
  props<{ filename: string }>()
);
export const setDownloadDocumentId = createAction(
  '[General] Set Download Document Id',
  props<{ documentId: number }>()
);
